import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../layout/Dialog';
import Button from '../form/Button';
import { truncate } from 'lodash';
import Text from './Text';

const TextPreview = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleModal = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  if (!props.text) {
    return null;
  }
  if (props.text.length <= props.maxCharacters) {
    return props.text;
  }
  return (
    <div>
      <button
        onClick={toggleModal}
        type="button"
        style={{
          color: '#1890ff',
          background: 'none',
          border: 'none',
          margin: 0,
          padding: 0,
          outline: 'none',
          textAlign: 'justify',
          cursor: 'pointer',
        }}
      >
        <Text value={props.text} maxLength={props.maxCharacters} />
      </button>
      <Dialog
        isOpen={isOpen}
        onCancel={() => setIsOpen(false)}
        title="Text Preview"
        width={720}
        actions={[<Button key="closeButton" icon="close-circle" label="Close" onClick={toggleModal} />]}
      >
        {props.text.split('\n').map((text) => (
          <p key={truncate(text, { length: 15 })} style={{ textIndent: 30 }}>
            {text}
          </p>
        ))}
      </Dialog>
    </div>
  );
};

TextPreview.propTypes = {
  text: PropTypes.string,
  maxCharacters: PropTypes.number,
};

TextPreview.defaultProps = {
  maxCharacters: 150,
};

export default TextPreview;
